import { Alert, Grid, Typography } from '@mui/material'
import type { FC } from 'react'

import PageContainer from '@/components/UI/PageContainer'

const NotFoundPage: FC = () => (
  <PageContainer
    pageContent={
      <Grid
        container
        sx={{ height: '100vh', alignItems: 'center', justifyContent: 'center' }}
      >
        <Alert severity="error">
          <Typography component="p">The requested page could not be found.</Typography>
        </Alert>
      </Grid>
    }
  />
)

export default NotFoundPage
